import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Mountain Pass Conditions API
 */
export const wsdotMountainPassConditionsApiMeta: ApiMeta = {
  name: "wsdot-mountain-pass-conditions",
  baseUrl:
    "https://www.wsdot.wa.gov/traffic/api/mountainpassconditions/mountainpassconditionsrest.svc",
};
